












import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import AgroNotification from "@/components/agroNotification/AgroNotification.vue";
import { Notification } from "@/store/notification/types";
import * as notificationService from "@/services/notification/index";

@Component({
  name: "AgroNotificationList",
  components: {
    AgroNotification
  }
})
export default class AgroNotificationList extends Vue {
  private get notificationsList() {
    return this.$store.state.notification.notifications;
  }

  private cleanNotification(notification: Notification) {
    notificationService.removeNotification(notification);
  }
}
